module.exports = __webpack_public_path__ + "static/media/USYG102067.255cde8c.jpg";